module.exports = __webpack_public_path__ + "img/dataCenterInfrastructure03.4acd6235.png";